export type Lang = 'es' | 'en' | 'pt';

export function detectLangFromNavigator(): Lang {
  const locale = (navigator.language || 'es').toLowerCase();
  if (locale.startsWith('pt')) return 'pt';
  if (locale.startsWith('en')) return 'en';
  return 'es';
}

export function loadDictionary(lang: Lang): Record<string, string> {
  switch (lang) {
    case 'en':
      return require('../client/languages/en.json');
    case 'pt':
      return require('../client/languages/pt.json');
    case 'es':
    default:
      return require('../client/languages/es.json');
  }
}

export function t(dict: Record<string, string>, key: string): string {
  return dict[key] || key;
}
